export default "__VITE_ASSET__5261dfe0__"